
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from "vue-property-decorator";
import FILTERS from '@/filters';

@Options({})
export default class animatedCurrency extends Vue {

    @Prop() value: number;
    @Prop({ default: 2 }) decimals: number;

    displayValue: number = 0;
    rafId: number = null;
    observer: IntersectionObserver = null;
    hasAnimatedIn: boolean = false;

    mounted(){
        this.observer = new IntersectionObserver(entries => {
            if(!entries[0].isIntersecting)
                return;

            this.hasAnimatedIn = true;
            this.animateTo(this.value || 0);
            this.disconnectObserver();
        });
        this.observer.observe(this.$el);
    }

    @Watch('value')
    onValueChange(newVal: number){
        if(!this.hasAnimatedIn)
            return;

        this.animateTo(newVal || 0);
    }

    disconnectObserver(){
        if(this.observer){
            this.observer.disconnect();
            this.observer = null;
        }
    }

    animateTo(target: number){
        if(this.rafId){
            cancelAnimationFrame(this.rafId);
        }
        let start = this.displayValue;
        let startTime: number = null;
        let duration = 1000;

        let step = (timestamp: number) => {
            if(startTime === null){
                startTime = timestamp;
            }
            let progress = Math.min((timestamp - startTime) / duration, 1);
            let eased = 1 - Math.pow(1 - progress, 3);
            this.displayValue = start + (target - start) * eased;

            if(progress < 1){
                this.rafId = requestAnimationFrame(step);
            } else {
                this.displayValue = target;
                this.rafId = null;
            }
        }
        this.rafId = requestAnimationFrame(step);
    }

    beforeUnmount(){
        if(this.rafId){
            cancelAnimationFrame(this.rafId);
        }
        this.disconnectObserver();
    }

    get formattedValue(){
        return this.$filters.currency(this.displayValue, this.decimals);
    }

}
